import { ModalComponent } from './components/modal/modal.component';
import { MDBBootstrapModule } from 'angular-bootstrap-md';
import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CascadingPanelComponent } from './components/cascading-panel/cascading-panel.component';
import { CascadingCardComponent } from './components/cascading-card/cascading-card.component';
import { OverlayCardComponent } from './components/overlay-card/overlay-card.component';
import { PanelComponent } from './components/panel/panel.component';
import { ErrorComponent } from './components/error/error.component';
import { ProgressReportComponent } from './components/progress-report/progress-report.component';
import { NotesComponent } from './components/notes/notes.component';
import { FormsModule } from '@angular/forms';
import { CreateNoteComponent } from './components/notes/create-note/create-note.component';
import { FilterNotePipe } from '../pipes/filter-note.pipe';
import { DaysAgoPipe } from '../pipes/days-ago.pipe';
import { LoadingComponent } from './components/loading/loading.component';
@NgModule({
  imports: [FormsModule, CommonModule, MDBBootstrapModule.forRoot()],
  declarations: [
    CascadingPanelComponent,
    CascadingCardComponent,
    OverlayCardComponent,
    PanelComponent,
    ModalComponent,
    ErrorComponent,
    ProgressReportComponent,
    NotesComponent,
    CreateNoteComponent,
    FilterNotePipe,
    DaysAgoPipe,
    LoadingComponent,
  ],
  exports: [
    MDBBootstrapModule,
    CascadingPanelComponent,
    CascadingCardComponent,
    OverlayCardComponent,
    PanelComponent,
    ModalComponent,
    ErrorComponent,
    ProgressReportComponent,
    NotesComponent,
    CreateNoteComponent,
    FilterNotePipe,
    DaysAgoPipe,
    LoadingComponent,
  ],
  providers: [],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
